import { render, staticRenderFns } from "./goodsResources.vue?vue&type=template&id=6b03cd74&scoped=true"
import script from "./goodsResources.vue?vue&type=script&lang=js"
export * from "./goodsResources.vue?vue&type=script&lang=js"
import style0 from "./goodsResources.vue?vue&type=style&index=0&id=6b03cd74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03cd74",
  null
  
)

export default component.exports